import { Itinerary2 } from '~/models/Itinerary'
import { Lead } from '~/models/Lead'
import { Site2 } from '~/models/Site'
import { Spot2 } from '~/models/Spot'
import { BaseRepository } from '../baseRepository'
import { ApiItinerary } from '../itinerary/apiTypes'
import { ItineraryEntityMapper } from '../itinerary/entityMapper'
import { ApiSpot } from '../spot/apiTypes'
import { SpotEntityMapper } from '../spot/entityMapper'
import { BusinessApiMapper } from './apiMapper'
import { ApiLead, ApiLeadItinerary } from './apiTypes'

export class LeadRepository extends BaseRepository {
	private static resource = 'business'

	static async sendEmail(
		lead: Lead,
		site: Site2,
		spots?: Spot2[],
		itinerary?: Record<string, Spot2[]>,
		title?: string,
		assistantName?: string
	): Promise<string> {
		const body: ApiLead = BusinessApiMapper.toApiLead(
			lead,
			site,
			spots,
			itinerary,
			title,
			assistantName
		)
		const response: ApiLead = (await this.post(`${this.resource}/lead/`, body)) as ApiLead
		return response.id!
	}

	static async getSpots(leadId: string): Promise<Spot2[]> {
		const response: ApiSpot[] = await this.get(`${this.resource}/lead/${leadId}/spots/`)
		return SpotEntityMapper.toSpots(response!)
	}

	static async getItinerary(leadId: string): Promise<Record<string, Spot2[]>> {
		const response: ApiLeadItinerary = await this.get(
			`${this.resource}/lead/${leadId}/itinerary_days/`
		)
		return BusinessApiMapper.toLeadItinerary(response!)
	}

	static async createTrip(leadId: string): Promise<Itinerary2> {
		const response: ApiItinerary | undefined = await this.post(
			`${this.resource}/lead/${leadId}/itinerary/`
		)
		return ItineraryEntityMapper.toItinerary(response!)
	}
}
